import isEmpty from 'lodash.isempty';

export function isEmptyFarmFeedParamsSearch(params) {
  const { search, filters, date_start, date_end } = params;
  return !search && isEmpty(filters) && !date_end && !date_start;
}
